import { render, staticRenderFns } from "./ApprovalConfigurationDetailInput.vue?vue&type=template&id=162e4d42&scoped=true&"
import script from "./ApprovalConfigurationDetailInput.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfigurationDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalConfigurationDetailInput.vue?vue&type=style&index=0&id=162e4d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e4d42",
  null
  
)

export default component.exports